import React from 'react'
import { css } from '@emotion/react'
import { Card, colors, Column, CompanyLogo, font } from 'plume-ui'
import { formatDate } from '@/lib/date'
import { SearchResult } from '../../../types'
import { IcomoonIcon } from '../../atoms/IcomoonIcon'
import { LineClampText } from '../../atoms/LineClampText'
import { TagButton, TagButtonGroup } from '../../atoms/TagButton'
import { useUser } from '@/contexts/AuthContext'
import { isEnterpriseWithTrial } from '@/lib/user'

type Props = {
  company: SearchResult['companies']['data'][0]
}

export const SearchCompanyCard: React.FC<Props> = (props) => {
  const user = useUser()
  return (
    <Card
      css={css`
        border-bottom: 1px solid ${colors.gray50};
      `}
      className="company"
    >
      <Card.Content>
        <Column.Group>
          <Column size={1}>
            <a href={props.company.path}>
              <CompanyLogo
                src={props.company.imageUrl}
                name={props.company.name}
                size="large"
              />
            </a>
          </Column>
          <Column>
            <div
              css={css`
                margin-left: 20px;
              `}
            >
              <div>
                <a
                  href={props.company.path}
                  css={css`
                    color: ${colors.black10};
                    font-size: 16px;
                    font-weight: ${font.weight.bold};
                    line-height: 1.4;
                    border-bottom: 1px solid transparent;
                    &:hover {
                      border-bottom: 1px solid ${colors.black10};
                    }
                  `}
                  className="name"
                >
                  {props.company.name}
                </a>
              </div>
              <div
                css={css`
                  margin-top: 5px;
                `}
              >
                <LineClampText lineNumber={2} size="14px">
                  {props.company.description}
                </LineClampText>
              </div>
              <TagButtonGroup
                css={css`
                  margin-top: 5px;
                `}
              >
                {props.company.tags.map((tag, i) => (
                  <TagButton key={i} tag={tag} />
                ))}
              </TagButtonGroup>
            </div>
          </Column>
          <Column
            size={2}
            css={css`
              > div {
                margin-bottom: 8px;
                display: flex;
                align-items: center;
                font-size: 14px;
              }

              i {
                color: ${colors.textLight};
                margin-right: 15px;
              }
            `}
          >
            <div>
              <IcomoonIcon name="person-fill" />
              <span>{props.company.representative || <EmptyItem />}</span>
            </div>
            <div>
              <IcomoonIcon name="flag1" />
              <span>
                {props.company.established ? (
                  formatDate(props.company.established, 'yyyy')
                ) : (
                  <EmptyItem />
                )}
                年設立
              </span>
            </div>
            <div>
              <IcomoonIcon name="spot1" />
              {props.company.state || <EmptyItem />}
            </div>
            {isEnterpriseWithTrial(user) && (
              <div>
                <IcomoonIcon name="people-fill" />
                <span>
                  {props.company.employees ? (
                    props.company.employees
                  ) : (
                    <EmptyItem />
                  )}
                  人
                </span>
              </div>
            )}
          </Column>
        </Column.Group>
      </Card.Content>
    </Card>
  )
}

const EmptyItem = () => {
  return (
    <span
      css={css`
        padding: 0 10px;
        font-size: 16px;
        color: ${colors.gray90};
      `}
    >
      -
    </span>
  )
}
